import { useDispatch, useSelector } from "react-redux";

import { RootState } from "@/store";
import { setSelectedFeature } from "@/store/slice/mapSlice";
import { toggleLegendInfo } from "@/store/slice/uiSlice";

const useHandleClearView = () => {
  const dispatch = useDispatch();
  const { showLegendInfo } = useSelector((state: RootState) => state.ui);
  const { selectedFeature } = useSelector((state: RootState) => state.map);

  // Check to close detail view
  const handleCloseDetailView = () => {
    // Map detail view
    if (selectedFeature) {
      dispatch(setSelectedFeature(null));
    }
    // Legends info
    if (showLegendInfo) {
      dispatch(toggleLegendInfo());
    }
  };

  return {
    handleCloseDetailView
  };
};

export default useHandleClearView;
